module.exports = __webpack_public_path__ + "img/ic_social_google.e690f7d7.svg";